module.exports = __webpack_public_path__ + "img/pb4.89aba299.jpg";